import type { FaireProductEntity } from "../../entity_types/product";

export const p_skw5xn4xhb: FaireProductEntity = {
  token: "p_skw5xn4xhb",
  type: "product",
  name: "Moroccan Cone Jug - Green",
  brandToken: "b_6xvu4qtx",
  brandName: "Verve Culture",
  imageUrl:
    "https://cdn.faire.com/fastly/ab3cd94928a210f2a2f596ac2f77910fe20c4e00a61f11a09ae45d32aaef761b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/48601a8fb8b53cf76d829a6b6abad8b0c45826fe53baee31d3ecad6cf9057ff9.jpeg",
    "https://cdn.faire.com/fastly/87f24e4d4463943db5c128c385053d06346d96ba7b5d76876347ee80d334ab02.jpeg",
    "https://cdn.faire.com/fastly/12fde2987a1d773269625e190f295912e5d6f2ea78bd1e53b07649d0638f3ad3.jpeg",
    "https://cdn.faire.com/fastly/c00d7f9850c9abdf48bb1054946f07750ecee6ced09f47722f1ddd75dfdb2117.jpeg",
    "https://cdn.faire.com/fastly/a34b8b95f0a48e73301dbffdc785a329a63d496ae475559651afd8e886fcadbc.jpeg",
    "https://cdn.faire.com/fastly/9ce7017814ba2ee51098222fa9cc62058ab0b2be0db3d7dd4fd56547cac55d78.jpeg",
    "https://cdn.faire.com/fastly/de83ab92e01793e88911aaa8f4f42a7d6f9328b46870122e8b1912f07c70396f.jpeg",
    "https://cdn.faire.com/fastly/9c037258cb14daa2fef3200693b275939c19b053db3f14ab0ca79c8094ede6b7.jpeg",
    "https://cdn.faire.com/fastly/1fdcd3cf5ecfd1098a509368005d2cd632a9191764424727250fe3d7b919103e.jpeg",
  ],
  priceDollars: 23,
  description:
    "*See separate listings for all color options\n\nThe sleek and simple design of these hand-blown cone shaped jugs are a testament to the style and skill of the artisans who make them. The handle fits perfectly in your hand as you pour your favorite beverage.  Used for all types of drinks, these jugs are a great compliment to any table setting adding color and culture to your table.\n\nMade from recycled beer and wine bottles, these beautiful jugs are a second act for glass that would otherwise be sent to landfills. \n\nOur Moroccan glassware jugs come in four distinct shades of transparent glass (Clear, Amber, Blue & Green). The handblown construction is evident in the bubbles suspended in the glass itself, and the organic forms that the vessels take.\n\nDishwasher safe.\n\n*Please note: handblown glass is sensitive to drastic temperature changes.",
  tags: [],
  msrpDollars: 46,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-05T16:55:05.284Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
